import { render } from "./Collaborate.vue?vue&type=template&id=137556f8&scoped=true"
import script from "./Collaborate.vue?vue&type=script&lang=js"
export * from "./Collaborate.vue?vue&type=script&lang=js"

import "./Collaborate.vue?vue&type=style&index=0&id=137556f8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-137556f8"]])

export default __exports__